import React from 'react';
import {createPortal} from "react-dom";
import {SHOPS_BY_BRAND_CONTAINER_ID} from "../../constants";
import {useAquaSheetContext} from "../../context/aquaSheetContext";
import ShopList from "../ShopList";
import classNames from "classnames";
import './style.css';

const AquaSheetShopContainer = ({children, closeHandler}) => {
    const mount = document.getElementById(SHOPS_BY_BRAND_CONTAINER_ID);

    const [{shopsQueryState, gtmClassName}] = useAquaSheetContext();

    if (!mount) return null;
    return createPortal(
        <div className="aquaSheet">
            <div className={classNames("storelocator", gtmClassName, "col")}>
                <ShopList shopsQueryState={shopsQueryState} />
            </div>
        </div>, mount);
}
export default AquaSheetShopContainer;